module.exports = require('./helpers/bundle-url').getBundleURL('5VCOe') + "logo.c51670a8.svg";